import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function CredentialsPage() {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    // {
    //   title: "Secret",
    //   dataIndex: 'secret',
    //   key: 'secret'
    // }
  ];

  const formFields = [
    {
      name: 'id',
      label: 'Id',
      type: 'id',
      placeholder: 'Credential Id',
      disabled: true,
    },
    {
      name: 'name',
      label: 'Credential Name',
      type: 'textarea',
      placeholder: 'Name',
      rules: [{ required: true, message: 'Must Enter a Credential Name!' }]
    },
    {
      name: 'secret',
      label: 'Secret',
      type: 'password',
      placeholder: 'secret',
      rules: [{ required: true, message: 'Must Enter a Credential Secret!' }]
    }
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/credentials"
        readEndpoint="read/credentials"
        editEndpoint="update/credentials"
        deleteEndpoint="delete/credentials"
        columns={columns}
        formFields={formFields}
        title="Credentials"
      />
    </div>
  );
}